// Copyright (c) StrangeBee 2023

import { Route as LoginRoute } from './login';
import { Route as SendPasswordResetRoute } from './SendPasswordReset';
import { Route as ChangePasswordRoute } from './ChangePassword';

export default [LoginRoute, SendPasswordResetRoute, ChangePasswordRoute];
